import styled from 'styled-components';

export const Container = styled.form`
  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 1.2rem;
  }

  .spanEmail {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.2rem;
    font-weight: bolder;
  }

  .divTitle {
    display: grid;
    grid-template-columns: 1fr 15fr;
    gap: 1rem;
    margin-bottom: 1.5rem;

    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      p,
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    svg{
      fill: ${({ theme }) => theme.colors.secondary};
    }
  }

  .divVerify {
    margin: 1rem 0rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      color: ${({ theme }) => theme.colors.primary};
    }

    .disabled-link {
      cursor: not-allowed;
      pointer-events: none;
      color: ${({ theme }) => theme.colors.text};
    }
  }

  @media (max-width: 350px) {
    .divTitle {
      svg {
        width: 2rem;
      }
    }
  }
`;
